import React from 'react';
import { ApolloProvider, useQuery, gql } from '@apollo/client';
import { IntlProvider } from 'react-intl';
import client from '../../lib/apolloClient';
import getMessages from '../../lib/i18n/getMessages';
import { CurrencyProvider } from '../../hooks/useCurrency';
import FinancingCalculator from '../../components/Succession/Financing/FinancingCalculator';

const LENDERS_QUERY = gql`
  query LendersQuery {
    lenders {
      id
      name
      description
      roi
      loan_amount_minimum
      loan_amount_maximum
      loan_amortization_minimum
      loan_amortization_maximum
      small_logo_url
      large_logo_url
      contact_name
      contact_email
      fees_info
      structure_info
      prepayment_info
      other_considerations_info
      minimum_loan_amount
      maximum_loan_amount
      amortization_periods
      rate_bands {
        id
        loan_amount_lower_band
        loan_amount_upper_band
        variable_interest_rate
        maximum_loan_to_value
      }
    }
  }
`;

function FinancingCalculatorInner() {
  const { loading, error, data } = useQuery(LENDERS_QUERY, { errorPolicy: 'all' });
  const hasFatalError = Boolean(error) && !(data?.lenders && data.lenders.length > 0);

  return (
    <FinancingCalculator
      lenders={data?.lenders || []}
      loading={loading}
      error={hasFatalError ? error : null}
    />
  );
}

const FinancingCalculatorContainer = (props) => {
  const locale = window.locale || 'en';

  return (
    <CurrencyProvider currency={window.currency || 'USD'}>
      <IntlProvider locale={locale} messages={getMessages(locale)}>
        <ApolloProvider client={client}>
          <FinancingCalculatorInner />
        </ApolloProvider>
      </IntlProvider>
    </CurrencyProvider>
  );
};

export default FinancingCalculatorContainer;
